import React from "react"
import { Button } from "reactstrap"

const ViewOnWebsite = ({ stock_id }) => {
  return (
    <Button
      color="warning"
      className="mb-2"
      size="sm"
      onClick={() =>
        window.open(
          `https://aurobilcars.com/vehicle/${stock_id}`,
          "_blank"
        )
      }
    >
      View on Website
    </Button>
  )
}

export default ViewOnWebsite
